// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { Models } from "@hex-insights/app-modules";
import { Button } from "@hex-insights/core";
import {
	AddSubFormButtonRenderProps,
	BooleanField,
	DateTimeField,
	FileUploadField,
	Form,
	SubFormField,
	SubFormRenderProps,
} from "@hex-insights/forms";
import { ReportCardFormValues, ReportCardSectionFormValues } from "../../FormUtilities";
import { AcademicTermSelectField } from "../AcademicTerm";
import { ReportCardSectionForm } from "../ReportCardSection";
import { BaseFieldProps } from "../shared";
import { StudentSelectField } from "../Student";
import { UserSelectField } from "../User";

/**
 * Generic props for fields of the ReportCard model.
 */
type FieldProps<K extends keyof ReportCardFormValues.Base = keyof ReportCardFormValues.Base> = BaseFieldProps<
	Pick<ReportCardFormValues.Base, K>
>;

/**
 * Generic props for fields of the ReportCard model that only appear in the create form.
 */
type CreateFieldProps<K extends keyof ReportCardFormValues.Create = keyof ReportCardFormValues.Create> = BaseFieldProps<
	Pick<ReportCardFormValues.Create, K>
>;

/**
 * Generic props for fields of the ReportCard model that only appear in the detail form.
 */
type DetailFieldProps<K extends keyof ReportCardFormValues.Detail = keyof ReportCardFormValues.Detail> = BaseFieldProps<
	Pick<ReportCardFormValues.Detail, K>
>;

/**
 * Field component for the `isComplete` field of the ReportCard model.
 */
export function IsComplete({ formState, ...props }: FieldProps<"isComplete">) {
	return <BooleanField formState={formState} name="isComplete" {...props} />;
}

/**
 * Field component for the `releaseDate` field of the ReportCard model.
 */
export function ReleaseDate({ formState, ...props }: FieldProps<"releaseDate">) {
	return <DateTimeField formState={formState} name="releaseDate" optional precision="day" {...props} />;
}

/**
 * Field component for the `isReleased` field of the ReportCard model.
 */
export function IsReleased({ formState, ...props }: FieldProps<"isReleased">) {
	return <BooleanField formState={formState} name="isReleased" {...props} />;
}

/**
 * Field component for the `file` field of the ReportCard model.
 */
export function File({ formState, url, ...props }: FieldProps<"fileKey" | "fileContentType"> & { url?: string }) {
	Models.requireURLForUpdateForm(url, false, formState.formType, "File");

	return (
		<FileUploadField
			formState={formState}
			keyFieldName="fileKey"
			contentTypeFieldName="fileContentType"
			url={url}
			optional
			{...props}
		/>
	);
}

export namespace AcademicTerm {
	export type SelectProps = FieldProps<"academicTermID"> &
		Omit<AcademicTermSelectField.SelectProps<ReportCardFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `academicTerm` edge of the ReportCard model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <AcademicTermSelectField.Select formState={formState} name="academicTermID" {...props} />;
	}
}

export namespace ApprovingUser {
	export type SelectProps = DetailFieldProps<"approvingUserID"> &
		Omit<UserSelectField.SelectProps<ReportCardFormValues.Detail>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `approvingUser` edge of the ReportCard model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <UserSelectField.Select formState={formState} name="approvingUserID" optional {...props} />;
	}
}

export namespace ReportCardSections {
	/**
	 * SubForm field component for the `reportCardSections` edge of the ReportCard model.
	 */
	export function SubForm({ formState, ...props }: CreateFieldProps<"reportCardSections">) {
		return (
			<SubFormField
				formState={formState}
				name="reportCardSections"
				blankItem={ReportCardSectionFormValues.blankItemInReportCard}
				{...props}
			>
				{SubForm.SubForm}
				{SubForm.AddButton}
			</SubFormField>
		);
	}

	SubForm.SubForm = function ({
		formState,
		onRemoveClick,
	}: SubFormRenderProps<ReportCardSectionFormValues.CreateInReportCard>) {
		return (
			<Form.Column>
				<Button variant="tertiary" size="small" onClick={onRemoveClick} disabled={formState.disabled}>
					Remove Report Card Section
				</Button>
				<ReportCardSectionForm.CreateFieldsInReportCard formState={formState} />
			</Form.Column>
		);
	};

	SubForm.AddButton = function ({
		onClick,
		disabled,
	}: AddSubFormButtonRenderProps<
		Pick<ReportCardFormValues.Create, "reportCardSections">,
		ReportCardSectionFormValues.CreateInReportCard
	>) {
		return (
			<Button variant="tertiary" size="small" onClick={onClick} disabled={disabled}>
				Add Report Card Section
			</Button>
		);
	};
}

export namespace Student {
	export type SelectProps = FieldProps<"studentID"> &
		Omit<StudentSelectField.SelectProps<ReportCardFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `student` edge of the ReportCard model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <StudentSelectField.Select formState={formState} name="studentID" {...props} />;
	}
}
